import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { PageErrorBoundary } from '@/components/PageErrorBoundary';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: ReactNode;
}

const pageVariants = {
  initial: {
    opacity: 0,
    y: 12,
    scale: 0.98,
  },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
  },
  exit: {
    opacity: 0,
    y: -8,
    scale: 0.98,
  },
};

const pageTransition = {
  type: 'tween' as const,
  ease: [0.25, 0.46, 0.45, 0.94] as [number, number, number, number],
  duration: 0.3,
};

export function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  // PageErrorBoundary key=pathname → reset boundary po navigaci, chyba na 1 stránce
  // nezatuhne i po překliknutí jinam.
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      transition={pageTransition}
      className="w-full h-full"
    >
      <PageErrorBoundary key={location.pathname} pageName={location.pathname}>
        {children}
      </PageErrorBoundary>
    </motion.div>
  );
}
